import $ from "jquery";

$(document).on("click", ".mobile-toggle", function () {
	if ($(".mobile-nav").hasClass("open")) {
		$(".mobile-nav").removeClass("open");
		$(".mobile-toggle").removeClass("open");
	} else {
		$(".mobile-nav").addClass("open");
		$(".mobile-toggle").addClass("open");
	}
});

$(document).on("click", ".mobile-nav .mobile-toggle", function () {
	$(".mobile-nav").removeClass("open");
	$(".mobile-toggle").removeClass("open");
});

$(document).on("click", function (event) {
	if (!$(event.target).closest(".mobile-toggle, .mobile-nav").length) {
		$(".mobile-nav").removeClass("open");
		$(".mobile-toggle").removeClass("open");
	}
});

$(".toggle-search").on("click", function () {
	$(".mobile-nav .material-input").addClass("open");
});
